import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  previewFooter: {
    display: 'flex',
    width: '100%',
    background: theme.palette.background.paper,
    gap: '8px',
    position: 'fixed',
    bottom: '0',
    padding: '1rem 0'
  }
}));
